module.exports = __webpack_public_path__ + "img/scoprum.db313683.svg";